export var AuthenticationResponse;
(function (AuthenticationResponse) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/halo/invitations.proto}
     */
    let Status;
    (function (Status) {
        Status[Status["OK"] = 0] = "OK";
        Status[Status["INVALID_OTP"] = 1] = "INVALID_OTP";
        Status[Status["INVALID_OPT_ATTEMPTS"] = 2] = "INVALID_OPT_ATTEMPTS";
        Status[Status["INTERNAL_ERROR"] = 3] = "INTERNAL_ERROR";
    })(Status = AuthenticationResponse.Status || (AuthenticationResponse.Status = {}));
})(AuthenticationResponse || (AuthenticationResponse = {}));
//# sourceMappingURL=invitations.js.map